import React from 'react';

import { useGetUsersForMentions } from './useMentionUsers';

export function UserMarkdownElement({
  id,
  users,
  loading,
}: {
  id: string;
  users: ReturnType<typeof useGetUsersForMentions>['users'];
  loading: boolean;
}) {
  const user = users.find((u) => u.userId === id);

  if (loading || !user?.fullName) {
    return <>@{id}</>;
  } else {
    return <span className="font-semibold text-black">@{user.fullName}</span>;
  }
}
